import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav2").addClass("active");
var swiper = new Swiper(".section1 .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 63,
    loop:true,
    navigation: {
        nextEl: '.section1 .swiper-button-next',
        prevEl: '.section1 .swiper-button-prev',
      },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 63,
        }
    },
});
var swiper = new Swiper(".section2 .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 63,
    loop:true,
    navigation: {
        nextEl: '.section2 .swiper-button-next',
        prevEl: '.section2 .swiper-button-prev',
      },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 63,
        }
    },
});